// components/WelcomeScreen.jsx
import React from "react";
import styles from "./Welcomescreen.module.css";

/**
 * WelcomeScreen
 * @param {string}   title
 * @param {string}   subtitle
 * @param {string}   buttonText
 * @param {string}   skipLabel  - anchor text (default "Skip to Home")
 * @param {string}   skipLink   - href for the skip anchor (default "/home")
 * @param {function} onStart    - called when CTA button clicked
 * @param {function} onSkip     - optional extra onClick for the skip link
 */
const WelcomeScreen = ({
  title = "Hi 👋 I'm your health assistant",
  subtitle = "Let's get to know you better (takes 10 seconds)",
  buttonText = "Let's start",
  skipLabel = "Skip to Home",
  skipLink = "/",
  onStart,
  onSkip,
}) => (
  <>
   
    <div className={styles.wrapper}>

      {/* <a> gives a real navigable link; onSkip fires extra logic if needed */}
      <a
        className={`ava-text-sm ${styles.skipLink}`}
        href={skipLink}
        onClick={onSkip}
      >
        {skipLabel}
      </a>

      <div className={styles.body}>
        <h1 className={`ava-heading-lg ${styles.title}`}>{title}</h1>
        <p className={`ava-text-body`}>{subtitle}</p>
        <button className={`btn-primary ${styles.ctaBtn}`} onClick={onStart} type="button">
          {buttonText}
        </button>
      </div>
    </div>
  </>
);

export default WelcomeScreen;